import { IReactiveModel, ViewModel } from '@descomplica/microfrontend-core';
import { action, makeObservable, observable } from 'mobx';

@ViewModel({ singleton: true })
export class ExamTimerViewModel implements IReactiveModel {
  @observable viewTimer = true;
  @observable count = 0;
  @observable intervalSeconds = 0;

  constructor() {
    makeObservable(this);
  }

  @action
  async onInit() {}

  @action
  formatSecondsToTime(seconds: number): string {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;

    return `${hours}h ${minutes}m ${remainingSeconds}s`;
  }

  @action
  toggleViewTimer(): void {
    this.viewTimer = !this.viewTimer;
  }

  @action
  setCount(count: number): void {
    this.count = count;
  }

  @action
  setIntervalSeconds(intervalSeconds: number): void {
    this.intervalSeconds = intervalSeconds;
  }
}
